import { Radar, Search } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.13 — Kalit so'zlar reyestri. Kuzatiladigan kalit so'z + maqsad sahifa +
 * maqsad pozitsiya + izoh. CRUD `/admin/seo/keywords` (real seo_config jadval).
 */
export function KeywordsScreen() {
  return (
    <SeoConfigTable
      screenId="A12.13"
      title={S.keywords}
      addLabel={S.addKeyword}
      path="/admin/seo/keywords"
      listKey="keywords"
      searchKeys={['keyword', 'page']}
      icon={<Search size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'keyword', placeholder: S.keyword },
        { name: 'page', placeholder: '/blog/seo', mono: true },
        { name: 'target_position', placeholder: S.targetPosition },
        { name: 'note', placeholder: S.note },
      ]}
      columns={[
        { key: 'keyword', header: S.keyword, type: 'text' },
        { key: 'page', header: S.targetPage, type: 'text' },
        { key: 'target_position', header: S.targetPosition, type: 'text' },
        { key: 'note', header: S.note, type: 'longtext' },
      ]}
    />
  )
}

/**
 * A12.14 — Raqobatchilar tahlili. Raqobatchi domen + nom + izoh reyestri.
 * CRUD `/admin/seo/competitors` (real seo_config jadval).
 */
export function CompetitorsScreen() {
  return (
    <SeoConfigTable
      screenId="A12.14"
      title={S.competitors}
      addLabel={S.addCompetitor}
      path="/admin/seo/competitors"
      listKey="competitors"
      searchKeys={['domain', 'name']}
      icon={<Radar size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'domain', placeholder: 'example.com', mono: true },
        { name: 'name', placeholder: S.name },
        { name: 'notes', placeholder: S.note },
      ]}
      columns={[
        { key: 'domain', header: S.domain, type: 'text' },
        { key: 'name', header: S.name, type: 'text' },
        { key: 'notes', header: S.note, type: 'longtext' },
      ]}
    />
  )
}
